const stock = (request, api_config) => {
  const prefix = 'Stock'

  const GetFilters = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetFilters`,
      method: 'get',
      params: data
    })
    return result
  }

  const GetCircle = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetCircle`,
      method: 'get',
      params: data
    })
    return result
  }

  const GetStockList = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockList`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBarcodeList = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBarcodeList`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchDetail = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchDetail`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchDetailList = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchDetailList`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchDetailFilter = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchDetailFilter`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchOrderDetail = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchOrderDetail`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchOrderFilter = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchOrderFilter`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchOrderList = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchOrderList`,
      method: 'post',
      data: data
    })
    return result
  }

  const GetStockBatchOrderListDetail = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStockBatchOrderListDetail`,
      method: 'post',
      data: data
    })
    return result
  }

  return {
    GetFilters,
    GetCircle,
    GetStockList,
    GetStockBarcodeList,
    GetStockBatchDetail,
    GetStockBatchDetailList,
    GetStockBatchDetailFilter,
    GetStockBatchOrderDetail,
    GetStockBatchOrderFilter,
    GetStockBatchOrderList,
    GetStockBatchOrderListDetail
  }
}

export default stock
